import { useRecoveryAccountContext } from "../../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import InputField from "../../../Components/InputField";
import DatePicker from "../../../Components/DatePicker";
import Button from "../../../Components/Button";
import dayjs from "dayjs";
import React from "react";
import axios from "axios";
import {
  CircularProgress,
  ThemeProvider,
  createTheme,
  MenuItem,
  Select,
} from "@mui/material";
import { baseUrl } from "../../../utilities/configurations";

const MaxicareCardPersonalInfo = () => {
  const {
    middleNameValidation,
    firstNameValidation,
    lastNameValidation,
    setBirthDate,
    setIsLoading,
    cardNumber,
    middleName,
    firstName,
    isLoading,
    setUserId,
    birthDate,
    navigate,
    lastName,
  } = useRecoveryAccountContext();

  const theme = createTheme({
    typography: {
      fontFamily: "Lato",
      body1: "black",
    },
  });

  const handleBack = () => {
    navigate(-1);
  };

  const handleNext = async () => {
    try {
      setIsLoading(true);
      const ip = await axios.get("https://api.ipify.org/?format=json");
      const city = await axios.get(
        `https://ipapi.co/${JSON.stringify(ip.data.ip).replaceAll(
          '"',
          ""
        )}/json/`
      );
      const verifyCardNumber = await axios.post(
        baseUrl + "/account-recovery/verify-account",
        {
          recoveryType: "CardNumber",
          recoveryValue: cardNumber.replace(/\s/g, ""),
          ipAddress: JSON.stringify(ip.data.ip).replaceAll('"', ""),
          location: JSON.stringify(city.data.city).replaceAll('"', ""),
          firstName: firstName,
          middleName: middleName,
          lastName: lastName,
          birthDate: birthDate,
        }
      );
      if (verifyCardNumber.data.status === true) {
        setUserId(verifyCardNumber.data.data.userId);
        setIsLoading(false);
        navigate("/recovery-account/maxicare-card-number/old-number");
      }
      if (verifyCardNumber.data.status === false) {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const personalValidation =
    firstName !== "" && lastName !== "" && birthDate !== undefined;

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-16 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Recover account
            </div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Enter your personal information
            </div>
            <div className="text-[#60656D] mt-2 mb-2">
              Please fill out this form accurately to help us keep your account
              secure by verifying it's really you
            </div>

            <div className="mt-1">
              <div className="mt-2">
                <div className="font-semibold">First name</div>

                <div className="mt-1">
                  <InputField
                    id="firstName"
                    value={firstName}
                    onChange={firstNameValidation}
                    maxLength="25"
                  />
                </div>
              </div>

              <div className="mt-2">
                <div className="font-semibold">Middle name</div>

                <div className="mt-1">
                  <InputField
                    id="middleName"
                    value={middleName}
                    onChange={middleNameValidation}
                    maxLength="25"
                  />
                </div>

                <div className="flex flex-row mt-2">
                  <input
                    className="w-3"
                    id="includeMiddleName"
                    type="checkbox"
                  />

                  <div className="ml-1 text-xs text-[#A3A7AB]">
                    I don't have a middle name
                  </div>
                </div>
              </div>

              <div className="mt-2">
                <div className="flex flex-row">
                  <div className="w-full">
                    <div className=" font-semibold">Last name</div>

                    <div className="w-full mt-1">
                      <InputField
                        id="lastName"
                        value={lastName}
                        onChange={lastNameValidation}
                        maxLength="25"
                      />
                    </div>
                  </div>

                  <div className="ml-2">
                    <div id="suffix" className="font-semibold">
                      Suffix
                    </div>

                    <ThemeProvider theme={theme}>
                      <Select
                        labelId="suffix"
                        className="w-20 h-10 mt-1"
                        id="suffixName"
                      >
                        <MenuItem value={"Sr."}>Sr.</MenuItem>
                        <MenuItem value={"Jr."}>Jr.</MenuItem>
                        <MenuItem value={"I"}>I</MenuItem>
                        <MenuItem value={"II"}>II</MenuItem>
                        <MenuItem value={"III"}>III</MenuItem>
                        <MenuItem value={"IV"}>IV</MenuItem>
                      </Select>
                    </ThemeProvider>
                  </div>
                </div>
              </div>

              <div className="mt-2">
                <div className=" font-semibold">Date of birth</div>

                <div className="mt-1">
                  <DatePicker
                    disablePast={false}
                    value={birthDate ? dayjs(birthDate) : undefined}
                    onChange={(newValue) => {
                      setBirthDate(dayjs(newValue).format("MM/DD/YYYY"));
                    }}
                    maxDate={dayjs().subtract(18, "years")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3">
          <Button
            disabled={!personalValidation || isLoading === true}
            className={`w-full h-12 mt-2 ${
              !personalValidation || isLoading === true
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleNext}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaxicareCardPersonalInfo;
